import React from 'react';
import { DataTableBox } from './DataTableBox';
import { DataBoxDefault, DataBoxProps } from './DataBoxDefault';

export type {
  DataBoxProps,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from './DataBoxDefault';

export const DataBox: React.FC<DataBoxProps> = (props) => {
  const { tableBox } = props;

  if (tableBox) {
    return <DataTableBox {...props} />;
  }
  return <DataBoxDefault {...props} />;
};
